export default __webpack_public_path__ + "static/media/1766.5b2b3846.png";